const e = {
  add: "Adicionar",
  cancel: "Cancelar",
  clear: "Limpar",
  confirm: "Confirmar",
  delete: "Excluir",
  redo: "Refazer",
  save: "Salvar",
  saveAs: "Salvar como",
  undo: "Desfazer"
}, a = {
  clear: "Limpar",
  confirm: "Confirmar",
  datePlaceholder: "Selecionar a data",
  datetimePlaceholder: "Selecionar a data e a hora",
  endDatePlaceholder: "Data de término",
  endDatetimePlaceholder: "Data e hora de término",
  endMonthPlaceholder: "Mês de término",
  monthPlaceholder: "Selecione o Mês",
  now: "Agora",
  quarterPlaceholder: "Selecione o Trimestre",
  selectDate: "Selecionar a data",
  selectTime: "Selecionar a hora",
  startDatePlaceholder: "Data de início",
  startDatetimePlaceholder: "Data e hora de início",
  startMonthPlaceholder: "Mês de Início",
  today: "Hoje",
  weekPlaceholder: "Selecionar a semana",
  yearPlaceholder: "Selecione o Ano"
}, o = {
  placeholder: "Selecione"
}, r = {
  clear: "Limpar",
  negativeText: "Cancelar",
  now: "Agora",
  placeholder: "Selecionar a hora",
  positiveText: "OK"
}, l = {
  placeholder: "Insira"
}, n = {
  placeholder: "Insira"
}, t = {
  placeholder: "Comece a digitar..."
}, s = {
  allRows: "Todas as linhas",
  default: "Padrão",
  deleteLayoutDescription: "Você tem certeza de que deseja excluir este layout?",
  discardChanges: "Descartar alterações",
  discardLayoutChanges: "Descartar alterações de layout",
  enterLayoutName: "Digite o nome do layout",
  enterRowNumber: "Digite o número de linhas",
  fieldsSelected: "campos selecionados",
  freezeColumnDescription: "Congele a coluna à esquerda",
  freezeUptoColumn: "Congele até a coluna",
  frozen: "Congelado",
  layoutName: "Nome do Layout",
  manageColumns: "Gerenciar colunas",
  none: "Nenhum",
  reorderRows: "Reordenar linhas",
  rowsSelected: "linhas selecionadas",
  saveLayoutAs: "Salvar layout como",
  saveLayoutNew: "Salvar novo layout",
  search: "Pesquisar",
  searchColumnsPlaceholder: "Pesquisar colunas",
  searchFieldsPlaceholder: "Campos de pesquisa",
  selectAll: "Selecionar tudo",
  setTableHeight: "Definir a altura da mesa",
  unfreeze: "Descongelar",
  unsavedChanges: "Você tem alterações não salvas",
  unsavedChangesDescription: "Pode haver uma ou mais alterações não salvas. Você quer salvá-las?"
}, c = {
  at: "em",
  colorAlreadyUsed: "Selecione uma cor diferente ou use a atual",
  colorNamePlaceholder: "Insira o nome",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Escolha um nome de cor diferente",
  noColorsAdded: "Você não tem nenhuma cor nesta seção."
}, i = {
  searchPlaceholder: "Pesquisar"
}, d = {
  invalidPastedData: "Dados colados inválidos"
}, u = {
  of: "de",
  page: "Página",
  rowsPerPage: "Linhas por página"
}, m = {
  failedToUpload: "Falha ao carregar",
  retry: "Tentar de novo",
  clickToUpload: "clicar para Carregar",
  orDragAndDrop: "Ou Arrastar e soltar",
  supportedFileTypes: "Tipos de arquivo compatíveis:"
}, h = {
  global: e,
  DatePicker: a,
  Select: o,
  TimePicker: r,
  Input: l,
  InputNumber: n,
  InputTag: t,
  HLDataTable: s,
  ColorPicker: c,
  InputPhone: i,
  InputOtp: d,
  Pagination: u,
  Upload: m
};
export {
  c as ColorPicker,
  a as DatePicker,
  s as HLDataTable,
  l as Input,
  n as InputNumber,
  d as InputOtp,
  i as InputPhone,
  t as InputTag,
  u as Pagination,
  o as Select,
  r as TimePicker,
  m as Upload,
  h as default,
  e as global
};
